type MobileNavHandlers = {
  open: () => void
  close: () => void
}

let handlers: MobileNavHandlers | null = null

/** Register sidebar open/close handlers from `DashboardShell` for tour orchestration. */
export function registerDashboardMobileNav(next: MobileNavHandlers): void {
  handlers = next
}

export function unregisterDashboardMobileNav(): void {
  handlers = null
}

export function openDashboardMobileNav(): void {
  handlers?.open()
}

export function closeDashboardMobileNav(): void {
  handlers?.close()
}
